import React from 'react'
import './style.css'

const EmptyMessage = ({children}) => {
    return (
        <div className="flex-container empty-message-container" >
            <span>{children}</span>
        </div>
    )
}

export default EmptyMessage